import { FEATURE_FLAGS } from "../../../constants/featureFlags";
import { getUserData } from "../../../services/API";

// react-i18next me
export const metrics = [
  {
    label: 'Overall Reading: ARM Score',
    value: 'ARM',
    scales: [
      {
        value: 'ARM',
        label: 'ARM Scale',
      },
    ],
    benchmarks: [
      {
        value: 'NationalNorms',
        grades: [0,1,2,3,4,5,6],
        seasons: ['Fall', 'Winter', 'Spring'],
        label: 'National Norms',
      },
    ],
    description: '',
    licenseScoreType: 'ARM',
  },
  {
    label: 'Overall Reading: ISIP Scaled Score',
    value: 'ISIP_overall_universal',
    scales: [
      {
        value: 'ISIP_overall_universal',
        label: 'ISIP Scaled Score',
      }
    ],
    benchmarks: [
      {
        value: 'NationalNorms',
        grades: [0,1,2,3,4,5,6],
        seasons: ['Fall', 'Winter', 'Spring'],
        label: 'National Norms',
      }
    ],
    description: '',
    locale: ['en-us'],
    licenseScoreType: 'ISIP',
  },
  {
    label: 'Oral Reading Fluency',
    value: 'ORF',
    scales: [
      {
        value: 'equatedWCPM',
        label: 'WCPM',
      },
      {
        value: 'DRA',
        label: 'Developmental Reading Assessment',
      },
    ],
    benchmarks: [
      {
        value: 'NationalNorms',
        grades: [0,1,2,3,4,5,6],
        seasons: ['Fall', 'Winter', 'Spring'],
        label: 'National Norms',
      },
      {
        value: 'Spanish',
        grades: [0,1,2,3,4,5],
        seasons: ['Fall', 'Winter', 'Spring'],
        label: 'Spanish Norms',
      }
    ],
    description: '',
  },
  {
    label: 'Lexile',
    value: 'Lexile',
    scales: [
      {
        value: 'Lexile',
        label: 'Lexile ',
      },
    ],
    benchmarks: [
      {
        value: 'NationalNorms',
        grades: [0,1,2,3,4,5,6],
        seasons: ['Fall', 'Winter', 'Spring'],
        label: 'National Norms',
      },
      {
        value: 'Spanish',
        grades: [0,1,2,3,4,5],
        seasons: ['Fall', 'Winter', 'Spring'],
        label: 'Spanish Norms',
      }
    ],
    description: '',
    locale: ['en-us'],
  },
  {
    label: 'Decoding',
    value: 'decodeScore',
    scales: [
      {
        value: 'decodeScore',
        label: 'ARM Scale',
      },
    ],
    benchmarks: [
      {
        value: 'NationalNorms',
        grades: [0,1,2,3,4,5,6],
        seasons: ['Fall', 'Winter', 'Spring'],
        label: 'National Norms',
      },
    ],
    description: '',
    locale: ['en-us'],
  },
  {
    label: 'Phonological Awareness',
    value: 'PhonologicalAwareness',
    scales: [
      {
        value: 'PSF',
        label: 'ARM Scale'
      },
    ],
    benchmarks: [
      {
        value: 'NationalNorms',
        grades: [0,1,2,3,4,5,6],
        seasons: ['Fall', 'Winter', 'Spring'],
        label: 'National Norms',
      },
      {
        value: 'Spanish',
        grades: [0,1,2,3,4,5],
        seasons: ['Fall', 'Winter', 'Spring'],
        label: 'Spanish Norms',
      }
    ],
    description: ''
  },
  {
    label: 'High Frequency Words',
    value: 'SightRecognition',
    scales: [
      {
        value: 'ESRI',
        label: 'ARM Scale'
      },
    ],
    benchmarks: [
      {
        value: 'NationalNorms',
        grades: [0,1,2,3,4,5,6],
        seasons: ['Fall', 'Winter', 'Spring'],
        label: 'National Norms',
      },
      {
        value: 'Spanish',
        grades: [0,1,2,3,4,5],
        seasons: ['Fall', 'Winter', 'Spring'],
        label: 'Spanish Norms',
      }
    ],
    description: ''
  },
  {
    label: 'Background Knowledge',
    value: 'bkScore',
    scales: [
      {
        value: 'bkScore',
        label: 'ARM Scale',
      },
    ],
    description: '',
    benchmarks: [
      {
        value: 'NationalNorms',
        grades: [0,1,2,3,4,5,6],
        seasons: ['Fall', 'Winter', 'Spring'],
        label: 'National Norms',
      },
    ],
    locale: ['en-us'],
  },
  {
    label: 'Structures & Reasoning',
    value: 'compScore',
    scales: [
      {
        value: 'compScore',
        label: 'ARM Scale',
      },
    ],
    benchmarks: [
      {
        value: 'NationalNorms',
        grades: [0,1,2,3,4,5,6],
        seasons: ['Fall', 'Winter', 'Spring'],
        label: 'National Norms',
      },
    ],
    description: '',
    locale: ['en-us'],
  },
  {
    label: 'Vocabulary',
    value: 'vocabularyScreenerScore',
    scales: [
      {
        value: 'vocabularyScreenerScore',
        label: 'ARM Scale',
      },
    ],
    benchmarks: [
      {
        value: 'NationalNorms',
        grades: [0,1,2,3,4,5,6],
        seasons: ['Fall', 'Winter', 'Spring'],
        label: 'National Norms',
      },
      {
        value: 'Spanish',
        grades: [0,1,2,3,4,5],
        seasons: ['Fall', 'Winter', 'Spring'],
        label: 'Spanish Norms',
      }
    ],
    description: '',
  },
];

export const comprehensiveAssessmentMetrics = [
  {
    label: 'Nonsense Word Fluency',
    value: 'NWF',
    scales: [
      {
        value: 'nwfCorrect',
        label: '# of Correct Answers',
      },
    ],
    benchmarks: [],
    description: '',
  },
  {
    label: 'Spelling (Encoding)',
    value: 'Spelling',
    scales: [
      {
        value: 'spellingCorrect',
        label: '# of Correct Answers',
      },
    ],
    benchmarks: [],
    description: '',
  },
]

export const dyslexiaMetric = {
  label: 'Dyslexia Risk Indicator (DRI)',
  value: 'DRI',
  scales: [
    {
      value: 'DR',
      label: 'Dyslexia Risk Score',
    },
  ],
  benchmarks: [
    {
      value: 'Dyslexia',
      grades: [0,1,2,3,4,5,6],
      seasons: ['Fall', 'Winter', 'Spring'],
      label: 'Risk Levels',
    },
  ],
  description: '',
}

// return the index of the default metric selection.
// the index follows the list of metrics defined above in metrics.js
export function getDefaultMetricSelection(){
  const {scoreType} = getUserData();
  if(scoreType === 'ISIP'){
    return metrics.findIndex(metric => metric.value === 'ISIP_overall_universal');
  }
  return metrics.findIndex(metric => metric.value === 'ARM') || 0;
}

export function getMetrics(){
  const {sorConfig, scoreType} = getUserData();

  let metricsToReturn = JSON.parse(JSON.stringify(metrics));

  // Remove entire Lexile metric if disabled
  if (!sorConfig.enableLexile) {
    metricsToReturn = metricsToReturn.filter(metric => metric.value !== 'Lexile');
  }

  // Remove DRA scale from ORF metric if disabled
  if (!sorConfig.enableDRA) {
    const orfMetricIndex = metricsToReturn.findIndex(metric => metric.value === 'ORF');
    if (orfMetricIndex !== -1) {
      metricsToReturn[orfMetricIndex].scales = metricsToReturn[orfMetricIndex].scales.filter(
        scale => scale.value !== 'DRA'
      );
    }
  }

  return metricsToReturn;
}